import {IAppState} from '../../state/AppState';

export const getMute = (state: IAppState) => state.messageData.mute;
